export default __webpack_public_path__ + "static/media/Logo.08ea5c89.jpg";